import { BadgeGroup } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";

interface BadgeGroupCellProps {
  value: {
    badges: string[];
    emptyText?: string;
    allText?: string;
  };
}

export const BadgeGroupCell: React.FC<BadgeGroupCellProps> = ({ value }) => {
  const { badges, emptyText = "None", allText = "All" } = value;

  if (!badges || badges.length === 0) {
    return <span>{emptyText}</span>;
  }

  if (badges.length === 1 && badges[0] === "All") {
    return <span>{allText}</span>;
  }

  const badgeItems = badges.map((badge) => ({
    text: badge,
    backgroundColor: "transparent",
    textColor: "#374151",
    borderColor: "#D1D5DB",
    borderWidth: "1px",
    maxWidth: "40%",
  }));

  return (
    <div className="badge-group-cell w-full">
      <BadgeGroup
        badges={badgeItems}
        maxVisible={2}
        size="medium"
        showOverflowTooltip={true}
      />
    </div>
  );
};

export default BadgeGroupCell;
